import { inmunetApi } from '../../../api';

export const getPaciente = async(id) => {

    try {

        const { data } = await inmunetApi.get(`/paciente/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data.paciente;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const updatePaciente = async({ data: paciente, id }) => {

    try {

        let formData = new FormData();
        Object.keys(paciente).forEach(field => {
            formData.append(field, paciente[field]);
        });

        const { data } = await inmunetApi.put(`/paciente/${ id }`, formData);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar datos';

        return data.paciente;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar datos');
        }

    }

};